<template>
  <div class="guideRegister">
    <h1>请填写基本信息</h1>
    <ul>
      <li>
        <span>真实姓名</span>
        <input maxlength="50" type="text" @input="parameter.nameState = false" :class="{ 'warning': parameter.nameState }" ref="inputName" v-model="parameter.name" placeholder="请输入您的姓名">
      </li>
      <li>
        <span>手机号码</span>
        <input type="tel" maxlength="11" v-mobile @input="parameter.phoneState = false" :class="{ 'warning': parameter.phoneState }" ref="inputPhone" v-model.number="parameter.phone" placeholder="请输入您的手机号码">
      </li>
      <li>
        <span>身份证号</span>
        <input type="text" :maxlength="IDCARDMAXLENGTH" @input="parameter.IdNumberState = false" :class="{ 'warning': parameter.IdNumberState }" ref="inputIdNumber" v-model="parameter.IdNumber" placeholder="请输入您的身份证号码">
      </li>
      <li>
        <span>导游证号</span>
        <input type="text" maxlength="14" @input="parameter.guideState = false" :class="{ 'warning': parameter.guideState }" ref="inputIdGuide" v-model="parameter.guideNumber" placeholder="请输入您的导游证号码">
      </li>
      <li>
        <span>邮箱</span>
        <input maxlength="50" type="email" @input="parameter.emailState = false" :class="{ 'warning': parameter.emailState }" ref="inputIdEmail" v-model="parameter.email" placeholder="请输入您的邮箱地址">
      </li>
    </ul>
    <div class="uploadImage">
      <div class="title">
        <span class="title-type">电子导游证</span><span @click="clickExamples" class="title-examples">查看示例</span>
      </div>
      <div class="userImage">
        <input
          style="display: none"
          type="file"
          accept="image/*"
          @change="changeImage($event)"
          ref="avatarInput"
          id="onloadImage"
        />
        <label v-if="imageState" for="onloadImage">
          <img ref="DOMShowImage" src="@/assets/image/register/user_image.png" alt="">
        </label>
        <img @click="displayImageDetails" v-else :src="updataImageBase64Data" alt="">
      </div>
      <div class="msg">请上传导游证照片，确保证件号码、二维码清晰可见</div>
    </div>
    <button @click="clickSubmit">提交</button>

    <div class="mask" v-if="examplesSwitch" @click.self="clickMask1">
      <!-- 没图暂缓 -->
      <main>
        <img src="@/assets/image/register/registr_examples.jpg" alt="">
        <div @click="examplesSwitch = false">关闭</div>
      </main>
    </div>
    <div class="mask2" v-if="imageShowPopup" @click.self="clickMask2">
      <!-- 没图暂缓 -->
      <main>
        <img :src="updataImageBase64Data" alt="">
        <div @click="clear">删除</div>
      </main>
    </div>
  </div>
</template>

<script>
import { sendGuideRegister, getupload } from '@/service/register';
import { IDCARDMAXLENGTH } from "@/global/global-constant";

export default {
  name: "guideRegister",
  data(){
    return {
      IDCARDMAXLENGTH,
      examplesSwitch: false,
      imageState: true,
      imageShowPopup: false,
      parameter:{
        name: '',
        nameState: false,
        phone: '',
        phoneState: false,
        IdNumber: '',
        IdNumberState: false,
        email: '',
        emailState: false,
        guideNumber: '',
        guideState: false,
        idCardUrl: '',
      },
      updataImageBase64Data: ''
    }
  },
  methods:{
    clickExamples(){
      this.examplesSwitch = true;
    },
    clickMask1(){
      this.examplesSwitch = false;
    },
    clickMask2(){
      this.imageShowPopup = false;
    },
    async changeImage(event){
        // 上传图片事件
        let file = event.target.files[0];
        const MAXMB = 2;
        const isLtSize = file.size / 1024 / 1024 < MAXMB;
        if(!isLtSize)return this.$toast(`上传图片大小不能超过 ${MAXMB}MB!`);
        let param = new FormData();
        param.append("file", file);
        this.updataImageBase64Data = await this.$getBase64(file);
        const { data } = await getupload.call(this, param);
        if(data){
          this.parameter.idCardUrl = data;
          this.imageState = false;
        };
    },
    displayImageDetails(){
      this.imageShowPopup = true;
    },
    async clickSubmit(){
      if(!this.parameter.name){
        this.$refs.inputName.focus();
        this.parameter.nameState = true;
        return this.$toast("姓名不能为空")
      };
      // if(!this.$reg.checkName.test(this.parameter.name)){
      //   this.$refs.inputName.focus();
      //   this.parameter.nameState = true;
      //   return this.$toast("姓名不能为数字不能含特殊符号")
      // };
      if(!this.parameter.phone){
        this.$refs.inputPhone.focus();
        this.parameter.phoneState = true;
        return this.$toast("手机号不能为空");
      };
      // this.parameter.phone
      if(!this.$reg.checkPhone(this.parameter.phone)){
        this.$refs.inputPhone.focus();
        this.parameter.phoneState = true;
        return this.$toast("手机号不正确");
      };
      if(!this.parameter.IdNumber){
        this.$refs.inputIdNumber.focus();
        this.parameter.IdNumberState = true;
        return this.$toast("身份证号不能为空");
      };
      if(!this.$reg.checkIDCard(this.parameter.IdNumber)){
        this.$refs.inputIdNumber.focus();
        this.parameter.IdNumberState = true;
        return this.$toast("身份证号不正确");
      };
      if(!this.parameter.guideNumber){
        this.$refs.inputIdGuide.focus();
        this.parameter.guideState = true;
        return this.$toast("导游证号不能为空");
      };
      if(this.parameter.guideNumber.length < 7 || this.parameter.guideNumber.length > 14){
        this.$refs.inputIdGuide.focus();
        this.parameter.guideState = true;
        return this.$toast("导游证号7-14位之间");
      };
      if(!this.parameter.email){
        this.$refs.inputIdEmail.focus();
        this.parameter.emailState = true;
        return this.$toast("邮箱地址不能为空");
      };
      if(!this.$reg.checkEmail(this.parameter.email)){
        this.$refs.inputIdEmail.focus();
        this.parameter.emailState = true;
        return this.$toast("邮箱号码错误");
      };
      if(!this.parameter.idCardUrl)return this.$toast("电子导游证未上传");
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      // 校准该接口时候替换正则表达式（原型链中已绑定）
      const data = await sendGuideRegister.call(this, {
        realName:this.parameter.name,
        mobile: this.parameter.phone,
        idCardNo: this.parameter.IdNumber,
        guideNo: this.parameter.guideNumber,
        email: this.parameter.email,
        openId: userInfo.openId,
        idCardUrl: this.parameter.idCardUrl,
        source: 'weixin',
      });
      if(data.status == "0")this.$router.push('/success');
    },
    clear(){
      this.updataImageBase64Data = '';
      this.$refs.avatarInput.value = '';
      this.parameter.idCardUrl = '';
      this.imageState = true;
      this.imageShowPopup = false;
    },
  },
  watch: {
    examplesSwitch(newValue){
      this.$beyondHiding(newValue)
    }
  }
};
</script>

<style scoped lang='less'>
.guideRegister{
  padding-bottom: 1.6rem;
  img{
    width: 100%;
    display: block;
  }
  h1{
    margin-top: .106667rem;
    font-size: 0.426667rem;
    line-height: .586667rem;
    background: #fff;
    padding: (0.533333rem / 2) .32rem;
  }
  ul{
    padding: 0 .32rem;
    background: #fff;
    line-height: 1.333333rem;
    margin-bottom: .106667rem;
    li{
      color: #3A3E5C;
      white-space: nowrap;
      border-bottom: 1px solid rgba(76, 92, 108, .16);
      display: flex;
      align-items: center;
      &:last-child{
        border: none;
      }
      span{
        font-size: .426667rem;
        margin-right: .8rem;
        display: inline-block;
        width: 4em;
      }
      input{
        height: 1.333333rem;
        font-size: .373333rem;
        flex: 1;
        &::placeholder{
          color: rgba(58, 62, 92, .4);
        }
      }
    }
  }
  .uploadImage{
    padding: .533333rem .32rem .16rem * 2;
    background: #FFFFFF;
    .title{
      .title-type{
        font-size: .426667rem;
      }
      .title-examples{
        font-size: .266667rem;
        margin-left: .16rem;
        color: rgba(58, 62, 92, .8);
      }
    }
    .userImage{
      margin-top: .213333rem;
      img{
        width: 1.6rem;
        display: block;
      }
    }
  }
  .msg{
    margin-top: .16rem;
    color: rgba(58, 62, 92, .56);
    font-size: .266667rem;
  }
  button{
    display: block;
    width: 4.346667rem * 2;
    line-height: .64rem * 2;
    background: #9D6C29;
    border-radius: .16rem;
    color: #FFFFFF;
    font-size: .24rem * 2;
    font-weight: bold;
    margin: 1.6rem auto 0;
    letter-spacing: .2em;
  }
}

.mask{
  position: fixed;
  height: 100vh;
  width: 100%;
  left: 0;
  top: 0;
  background: rgba(91, 95, 100, .77);
  main{
    position: absolute;
    width: 4.106667rem * 2;
    height: 5.066667rem * 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: rgb(102, 102, 102);
    display: flex;
    flex-direction: column;
    img{
      width: 60%;
      margin: .666667rem auto 0;
    }
    div{
      background: rgb(13, 13, 13);
      color: #fff;
      flex: 1;
      line-height: 1.333333rem;
      text-align: center;
      font-size: .426667rem;
    }
  }
}

.mask2{
  position: fixed;
  height: 100vh;
  width: 100%;
  left: 0;
  top: 0;
  background: rgba(91, 95, 100, .77);
  main{
    position: absolute;
    width: 4.106667rem * 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: rgb(102, 102, 102);
    display: flex;
    flex-direction: column;
    img{
      width: 60%;
      margin: .666667rem auto 0;
    }
    div{
      background: rgb(13, 13, 13);
      color: #fff;
      flex: 1;
      line-height: 1.333333rem;
      text-align: center;
      font-size: .426667rem;
    }
  }
}

.warning{
  border: 1px solid red;
}
</style>
